import * as React from "react";
import logo from "modules/development/assets/images/rubk-logo.svg";
import { Grid, CssBaseline, Typography } from "@material-ui/core";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import { Redirect } from "react-router-dom";
import i18n from "i18n";
import getQueryVariable from "common/actions/query";
import { AccountService } from "modules/account/AccountService";
import { StyleSheet, css } from "aphrodite";

const styles = StyleSheet.create({
  header: {
    backgroundColor: "#333",
    width: "100%",
    height: 64,
    padding: "20px 24px",
  },
  root: {
    width: "100%",
    padding: 2,
    paddingLeft: 23,
    height: 60,
    lineHeight: "60px",
    backgroundColor: "white",
  },
  displayName: {
    flexGrow: 1,
    backgroundColor: "#000000,5%",
    fontWeight: "700" as any,
    fontSize: "16px" as any,
    fontFamily: "Roboto",
  },
  formContainer: {
    margin: "0 auto",
    width: 640,
    paddingTop: 120,
  },
  textField: {
    marginTop: 16,
    width: "640px",
    margin: "0 auto",
  },
  buttonContainer: {
    margin: "0 auto",
    width: 138,
  },
  button: {
    color: "white",
    backgroundColor: "#ABC200",
    "&:hover": {
      backgroundColor: "rgba(171, 194, 0, 0.8)",
    },
  },
  messageContainer: {
    textAlign: "center" as any,
    "& p": {
      fontFamily: "Raleway",
      fontWeight: 300,
      fontSize: 26,
      margin: 0,
    },
  },
});

const Header = () => (
  <div className={css(styles.header)}>
    <img style={{ height: "21px" }} src={logo} />
  </div>
);

type IProps = {};

class ResetPassword extends React.Component<IProps> {
  state = {
    open: false,
    password: "",
    path: window.location.pathname,
    showPassword: false,
    message: "",
    displayName: "",
    redirect: "",
    email: "",
    componentMounted: false,
    finished: false,
  };

  componentDidMount() {
    let oobCode = getQueryVariable("oobCode");
    if (oobCode) {
      AccountService.verifyPassword(oobCode, (success, response) => {
        if (success) {
          this.setState({
            email: response.email,
            displayName: response.email,
            componentMounted: true,
          });
        } else this.setState({ componentMounted: true });
      });
    }
  }

  // PRUBK-899 - Adicionando outros Produtos
  redirect = (path: string) => {
    const continueUrl = getQueryVariable("continueUrl") || "";
    const rubkProduct = decodeURIComponent(continueUrl).split("/").pop();

    if (rubkProduct) {
      if (path !== "/Login") {
        // Sinaliza que a senha foi alterada
        this.setState({ componentMounted: false, finished: true });
      }

      window.open(`https://${rubkProduct}.firebaseapp.com/`);
      return;
    }

    this.setState({ redirect: path });
  };

  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  handleClickLoginAcount = () => {
    let oobCode = getQueryVariable("oobCode");
    if (oobCode != null) {
      AccountService.confirmResetPassword(
        oobCode,
        this.state.email,
        this.state.password,
        (success, user) => {
          if (success) {
            AccountService.loginUser(() => {
              this.redirect("/menu/development");
            });
          } else {
            this.setState({ message: user.message });
            this.setState({ open: true });
          }
        }
      );
    }
  };

  handleClickGoToLogin = () => {
    this.redirect("/Login");
  };

  renderForm = () => (
    <>
      <FormControl className={css(styles.textField)}>
        <InputLabel htmlFor="adornment-password">
          {i18n.login.newPassword}
        </InputLabel>
        <Input
          id="txtPassword"
          type={this.state.showPassword ? "text" : "password"}
          value={this.state.password}
          onChange={this.handleChange("password")}
          autoComplete="off"
          style={{ marginLeft: 0 }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={this.handleClickShowPassword}
              >
                {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      <div className={css(styles.buttonContainer)}>
        <Button
          onClick={() => this.handleClickLoginAcount()}
          size="small"
          variant="contained"
          fullWidth
          disabled={this.state.password.length < 6}
          className={css(styles.button)}
          style={{ padding: 8 }}
        >
          {i18n.login.reset}
        </Button>
      </div>
    </>
  );

  renderMessageContainer = (messages) => (
    <div className={css(styles.messageContainer)}>
      {messages}
      <div className={css(styles.buttonContainer)}>
        <Button
          onClick={() => this.handleClickGoToLogin()}
          style={{ width: "100%" }}
          size="small"
          variant="contained"
          className={css(styles.button)}
        >
          {i18n.login.enterRubk}
        </Button>
      </div>
    </div>
  );

  render() {
    return (
      <React.Fragment>
        <CssBaseline />
        <Grid container>
          <Grid item xs={12}>
            <Header />
          </Grid>
          <Grid item xs={12}>
            <div className={css(styles.root)}>
              {this.state.redirect !== "" && (
                <Redirect to={this.state.redirect} />
              )}

              <div className={css(styles.displayName)}>
                {this.state.displayName}
              </div>

              <div className={css(styles.formContainer)}>
                {this.state.displayName.length > 0 &&
                  this.state.componentMounted &&
                  this.renderForm()}

                {this.state.displayName.length == 0 &&
                  this.state.componentMounted &&
                  this.renderMessageContainer(
                    <>
                      <Typography variant="h5">
                        {i18n.login.emailError}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ paddingTop: "1.5rem" }}
                      >
                        {i18n.login.resendEmail}
                      </Typography>
                    </>
                  )}

                {this.state.finished &&
                  this.renderMessageContainer(
                    <>
                      <Typography variant="h5">
                        {i18n.login.resetPasswordSuccess}
                      </Typography>
                      <Typography
                        variant="body1"
                        style={{ paddingTop: "1.5rem" }}
                      >
                        {i18n.login.continue}
                      </Typography>
                    </>
                  )}
              </div>

              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                open={this.state.open}
                onClose={this.handleCloseSnack}
                ContentProps={{
                  "aria-describedby": "message-id",
                }}
                message={<span id="message-id">{this.state.message}</span>}
              />
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/modules/account/components/pages/ResetPassword.tsx